import React from 'react';
import { useSelector } from 'react-redux';
import { get_sample_types } from '../../../../redux/po_backlog/backlog.selector';
import { Box } from '@mui/material';
import SampleStatusSummary from '../../../BacklogInsights/Components/SampleStatus';

const AllSampleStatusSummary = () => {
  const sample_types = useSelector(get_sample_types);

  return (
    sample_types && sample_types?.map((sample_type, idx) =>
      <Box className="col-span-3 sm:col-span-1" key={`sample_status_summary${sample_type}${idx}`} >
        <SampleStatusSummary isSmall title={sample_type} />
      </Box>
    )
  );
};

export default AllSampleStatusSummary;